import React, { forwardRef } from 'react';
import { Button as ShadcnButton } from 'components/shadcn/ui/button';

const Button = forwardRef((props, ref) => {
    return (
        <ShadcnButton
            variant="outline"
            {...props}
            className={`text-foreground ${props.className}`}
            ref={ref}
        >
            {props.children}
        </ShadcnButton>
    );
});

export default Button;
